export enum categoryEvent {
  home = 'home_pricing',
}
